import * as React from 'react';
import { inputFormatters } from 'ui-common';
import DataInput from '../DataInput';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';

class PhoneInput extends React.Component<InputProps, {}> {
  // @ts-ignore
  private inputProps: DirectInputProps;
  // @ts-ignore
  private contextProps: DataInputContextProps;

  render() {
    const { input, placeholder, meta, label, mask } = this.props;
    this.inputProps = {
      ...input,
      id: getIdFromName(input.name),
      placeholder: mask ? mask.placeholder : placeholder, // TODO (UI-2778): remove branching
      type: 'tel',
    };

    this.contextProps = {
      error: meta.touched && meta.error,
      format: inputFormatters.PHONE.format as any,
      label: label || '',
      normalize: inputFormatters.PHONE.normalize,
      mask, // TODO (UI-2778): Use mask in all phoneInputs instead of just when it's defined by the form
    };

    return (
      <div className="PhoneInput">
        <DataInput inputProps={this.inputProps} contextProps={this.contextProps} />
      </div>
    );
  }
}

export const PhoneInputConfig = {
  component: PhoneInput,
  requiredLength: 10,
};

export default PhoneInput;
